module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/events/events.component.css
// module id = ./src/app/components/events/events.component.css
// module chunks = main